import React from "react";
import {styled, theme} from "@reside/ui";
import {getFacilityNamesSummary} from "./permissionsUserDetail.helpers";

type Props = Readonly<{
  facilities: ReadonlyArray<{name?: string}> | undefined;
  maxVisible?: number;
}>;

export const FacilityNamesOverflow = ({
  facilities,
  maxVisible = 2,
}: Props) => {
  const {visibleLabel, remainingCount} = getFacilityNamesSummary(
    facilities,
    maxVisible,
  );

  if (!visibleLabel) {
    return null;
  }

  return (
    <span>
      {visibleLabel}
      {remainingCount > 0 ? (
        <>
          {" "}
          <MoreLabel>+ {remainingCount} more</MoreLabel>
        </>
      ) : null}
    </span>
  );
};

const MoreLabel = styled.span`
  color: ${theme.color.darkBlue100};
  font-weight: 500;
`;
